module.exports = require("is-promise");